import HomeIcon from "@mui/icons-material/Home";
import PhoneIcon from "@mui/icons-material/Phone";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";

import React from "react";

export default function Footer() {
  const theme = useTheme();

  const scheduleItems = [
    { days: "Lundi au jeudi", hours: "8 h à 16 h 30" },
    { days: "Vendredi", hours: "8 h à 12 h" },
    { days: "Samedi et dimanche", hours: "Fermé" },
  ];

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.text.primary,
        pt: { xs: 6, md: 8 },
        pb: 3,
        mt: 8,
      }}
    >
      <Box
        sx={{
          px: "var(--section-margin-x, 40px)",
          maxWidth: "100%",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", lg: "row" },
            gap: { xs: 6, lg: 8 },
            mb: 6,
            justifyContent: "space-between",
          }}
        >
          {/* About Us Section */}
          <Box sx={{ flex: "0 0 auto", maxWidth: { xs: "100%", lg: "280px" } }}>
            <Typography variant="h5" sx={{ fontWeight: 700, mb: 2 }}>
              À propos
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: theme.palette.grey[300],
                lineHeight: 1.7,
              }}
            >
              Au Centre GRMO, votre bien-être est notre priorité. Notre équipe
              vous offre un accompagnement exceptionnel dans votre parcours de
              santé.
            </Typography>
          </Box>

          {/* Right Side: Horaire and Nos coordonnées */}
          <Box
            sx={{
              flex: "0 0 auto",
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              gap: { xs: 4, md: 6 },
            }}
          >
            {/* Horaire Section */}
            <Box sx={{ flex: 1 }}>
              <Typography variant="h5" sx={{ fontWeight: 700, mb: 3 }}>
                Horaire
              </Typography>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
                {scheduleItems.map((item, index) => (
                  <Typography
                    key={index}
                    variant="body2"
                    sx={{
                      color: theme.palette.grey[300],
                    }}
                  >
                    <Box
                      component="span"
                      sx={{
                        fontWeight: 600,
                        color: theme.palette.text.primary,
                      }}
                    >
                      {item.days}:
                    </Box>{" "}
                    {item.hours}
                  </Typography>
                ))}
              </Box>
            </Box>

            {/* Nos coordonnées Section */}
            <Box sx={{ flex: 1 }}>
              <Typography
                variant="h5"
                sx={{ fontWeight: 700, mb: 3, display: "flex", gap: 1 }}
              >
                Nos coordonnées
              </Typography>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                  <HomeIcon sx={{ fontSize: "1.25rem" }} />
                  <Box>
                    <Typography variant="body2">
                      1200, avenue de Germain-des-Prés, Bureau 100
                    </Typography>
                    <Typography variant="body2">
                      Québec (Québec) G1V 3M7
                    </Typography>
                  </Box>
                </Box>

                <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                  <PhoneIcon sx={{ fontSize: "1.25rem" }} />
                  <Typography
                    variant="body2"
                    component="a"
                    href="tel:4186502671"
                    sx={{
                      color: theme.palette.text.primary,
                      textDecoration: "none",
                      "&:hover": {
                        textDecoration: "underline",
                      },
                    }}
                  >
                    418 650-2671
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>

        <Divider
          sx={{
            backgroundColor: theme.palette.grey[300],
            opacity: 0.3,
            mb: 3,
          }}
        />

        <Box sx={{ textAlign: "center" }}>
          <Typography variant="caption" sx={{ color: theme.palette.grey[300] }}>
            © {new Date().getFullYear()} Centre de recherche en rhumatologie
            GRMO. Tous droits réservés.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
